window.addEventListener("scroll", function () {
  const elm = document.querySelector(".purchase_button");
  const scroll = window.pageYOffset;
  if (scroll > 700) {
    elm.style.opacity = "1";
    elm.style.zIndex = "1";
    // console.log(scroll);
  } else {
    elm.style.opacity = "0";
    elm.style.zIndex = "-1";
    // console.log(scroll);
  }

});